// extracted by mini-css-extract-plugin
module.exports = {"slickArrow":"Carousel_slickArrow__3yaKI","slickNext":"Carousel_slickNext__2RvAE","slickPrev":"Carousel_slickPrev__2ewTs"};